import { ComboHeader } from "components/blocks/ComboHeader";
import { routes } from "routes";
import { Tabs, TabName, UserList } from "./components";
import { useFollowersFeed } from "queries";
import { FooterAds } from "components/ads/FooterAds";
import { Fragment } from "react";

interface IProps {
  userName: string;
}

export const FollowersPage = (props: IProps) => {
  document.title = "Followers | RedGIFs";

  return (
    <Fragment>
      <div className="followersPage wide page">
        <ComboHeader back={routes.user(props.userName)} text="Followers" />
        <Tabs tab={TabName.Followers} />
        <UserList userName={props.userName} query={useFollowersFeed} />
      </div>
      <FooterAds/>
    </Fragment>
  );
};
